import axios from './defaultClient';

const nameSpace = '/ep/v1/user';
export const GetUser = async (args) => {
    return await axios.get( nameSpace + '/' + args.user_id,{})
}
